import Vue from 'vue'
import Router from 'vue-router'
import EmbedVideo from '@/components/EmbedVideo'
import EmbedVideoByTocken from '@/components/EmbedVideoByTocken'
import EmbedVideoByTokenAD from '@/components/EmbedVideoByTokenAd'
import WidgetVideoByTocken from '@/components/WidgetVideoByTocken'
import Page404 from '@/components/404'
import EmbedPlaylist from '@/components/EmbedPlaylist'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'embed_video',
      path: '/embed/:id',
      component:EmbedVideo
    },
    {
      name: 'export_video_ad_token',
      path: '/embed/export-ad/:token',
      component:EmbedVideoByTokenAD
    },
    {
      name: 'export_video_token',
      path: '/embed/export/:token',
      component:EmbedVideoByTocken
    },
    {
      name: 'widget_video_token',
      path: '/embed/widget/:token',
      component:WidgetVideoByTocken
    },
    {
      name: 'embed_video_token',
      path: '/embed/embed-:token',
      component:EmbedVideoByTocken
    },
    {
     path: '/embed/*',
     redirect: '/embed/error/404',
    },
    {
      path: '/embed/error/404',
      name: 'Page404',
      component: Page404
    },
    {
      name: 'embed_playlist',
      path: '/embed-playlist/:id',
      component:EmbedPlaylist
    },
  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js